export default __webpack_public_path__ + "static/media/blog_detail.c461acbf.jpg";